import { render, staticRenderFns } from "./StepInformacoes.vue?vue&type=template&id=f26c28b4&scoped=true"
import script from "./StepInformacoes.vue?vue&type=script&lang=js"
export * from "./StepInformacoes.vue?vue&type=script&lang=js"
import style0 from "./StepInformacoes.vue?vue&type=style&index=0&id=f26c28b4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f26c28b4",
  null
  
)

export default component.exports